export default __webpack_public_path__ + "static/media/external_talent.8f3048f1.svg";